export const colors = {
  orange: '#FE6611',
  blue: '#071C48',
  white: '#ffffff',
  plateBlue: '#013B9D',
  black: '#000000',
}